import { CSSProperties, FC } from "react";
import { PromotionBannerProps } from "./PromotionBannerTypes";
import { Text, Heading } from "@otrium/atoms";
import styles from "./PromotionBanner.module.scss";
import { PromotionBannerImage } from "./PromotionBannerImage";
import { BREAKPOINTS } from "src/breakpoints";

interface PromotionBannerTypeTwoProps extends PromotionBannerProps {
  backgroundColor: string;
}

const PromotionBannerTypeTwo: FC<PromotionBannerTypeTwoProps> = ({
  images,
  title,
  description,
  buttonTitle,
  buttonColor,
  buttonTextColor,
  conditionText,
  backgroundColor,
  hideCTAButton,
  titleColor,
  textColor,
  priority,
}) => {
  return (
    <div className={styles.typeTwoWrapper}>
      <div
        className={styles.typeTwoHeadingWrapper}
        style={{ "--banner-bg": backgroundColor } as CSSProperties}
      >
        <Heading
          as="h1"
          className={styles.typeTwoHeading}
          color={titleColor || "tone.white"}
          pb={0}
          fontSize={[4, 4, 4, 5]}
          lineHeight={["40px", "40px", "40px", "64px"]}
          fontWeight="700"
        >
          {title}
        </Heading>
        {description && (
          <Text
            as="p"
            fontSize={["fontSize18", "fontSize18", "22px"]}
            lineHeight={["24px", "24px", "32px"]}
            textAlign="center"
            color={textColor || "tone.white"}
            mb="space16"
          >
            {description}
          </Text>
        )}
        {!hideCTAButton ? (
          <div
            className={styles.fakeButton}
            style={
              {
                "--banner-button-color": buttonTextColor || "tone.white",
                "--banner-button-bg": buttonColor,
              } as CSSProperties
            }
          >
            {buttonTitle}
          </div>
        ) : null}
        {conditionText && (
          <Text
            fontSize="fontSize12"
            color={textColor || "tone.white"}
            textAlign="center"
          >
            {conditionText}
          </Text>
        )}
      </div>
      <div className={styles.typeTwoImgWrapper}>
        <PromotionBannerImage
          images={images}
          alt={title}
          className={styles.typeTwoPicture}
          sizes={`(max-width: ${BREAKPOINTS.sm}) 100vw, 57vw`}
          priority={priority}
        />
      </div>
    </div>
  );
};

export default PromotionBannerTypeTwo;
